module.exports = __webpack_public_path__ + "static/media/01.bb756183.mp3";